<template>
  <div class="px-2">
    <px-aprovacao-solicitacao-produtos-table :aprovacao="aprovacao"
                                             @update="emitUpdate"/>
  </div>
</template>

<script>
import pxAprovacaoSolicitacaoProdutosTable
  from '@/modules/aprovacao-solicitacao/components/AprovacaoSolicitacaoProdutosTable.vue';

export default {
  props: {
    aprovacao: {
      type: Object,
      required: true,
    },
  },
  methods: {
    emitUpdate(item) {
      this.$emit('update', item);
    },
  },
  components: {
    pxAprovacaoSolicitacaoProdutosTable,
  },
};
</script>
